/*global $*/

import ko from 'knockout';

export function registerComponent() {
  ko.components.register('persons-picker', {
    template: { element: 'persons-picker-template' },
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new PersonsPickerViewModel(params, componentInfo);
      },
    },
  });
}

function PersonsPickerViewModel(params, componentInfo) {
  var self = this;
  var $component = $(componentInfo.element);
  $component.change(function (event) {
    event.stopPropagation();
  });

  var persons = params.data;
  var close = params.close;
  var content = params.content;

  var minNumberOfAdults = 0;
  var maxNumberOfAdults = 40;
  var minNumberOfChildren = 0;
  var maxNumberOfChildren = 40;

  self.adults = persons.Adults;
  self.children = persons.Children;
  self.childAges = persons.ChildAges;

  setInitial();

  self.numberOfAdults = ko.observable(self.adults() ? parseInt(self.adults()) : 0);
  self.numberOfChildren = ko.observable(self.children() ? parseInt(self.children()) : 0);
  self.childrenAges = ko.observableArray();

  var updateChildren = function (newValue) {
    var c = newValue, l = self.childrenAges().length, d = l - c;
    if (d >= 0) {
      self.childrenAges.splice(c, d);
    } else {
      self.childrenAges.splice.apply(self.childrenAges, [c, 0].concat($.map(Array(0 - d), function (_, i) {
        return new ChildAgeViewModel(i + l, (i + l) < self.childAges().length ? self.childAges()[i + l].Age() : '', update);
      })));
    }
  };

  updateChildren(self.numberOfChildren());
  this.numberOfChildren.subscribe(updateChildren);

  this.children.subscribe(function (newValue) {
    var c = newValue, l = self.childAges().length, d = l - c;
    if (d >= 0) {
      self.childAges.splice(c, d);
    } else {
      self.childAges.splice.apply(self.childAges, [c, 0].concat($.map(Array(0 - d), function (_, i) {
        return { Index: ko.observable(i + 1), Age: ko.observable('') };
      })));
    }
    setContent();
  });

  this.adults.subscribe(setContent);

  setContent();

  params.onOpen(function onPersonsPickerOpen() {
    setInitial();

    self.numberOfAdults(self.adults() ? parseInt(self.adults()) : 0);
    self.numberOfChildren(self.children() ? parseInt(self.children()) : 0);
    for (var i = 0; i < self.childrenAges().length; i++) {
      self.childrenAges()[i].Age(self.childAges()[i].Age());
    }
  });

  params.onClear(function onPeriodPickerClear() {
    self.numberOfAdults(0);
    self.numberOfChildren(0);

    $(componentInfo.element).trigger('personsselected');
  });

  self.apply = function () {
    close();
  };

  self.cancel = function () {
    persons.Adults(self.initialNumberOfAdults);
    persons.Children(self.initialNumberOfChildren);
    for (var i = 0; i < persons.ChildAges().length; i++) {
      persons.ChildAges()[i].Age(self.initialChildAges[i]);
    }

    $(componentInfo.element).trigger('personsselected');

    close();
  };

  self.addAdult = function () {
    if (self.numberOfAdults() < maxNumberOfAdults) {
      self.numberOfAdults(self.numberOfAdults() + 1);
    }
  };

  self.removeAdult = function () {
    if (self.numberOfAdults() > minNumberOfAdults) {
      self.numberOfAdults(self.numberOfAdults() - 1);
    }
  };

  self.addChild = function () {
    if (self.numberOfChildren() < maxNumberOfChildren) {
      self.numberOfChildren(self.numberOfChildren() + 1);
    }
  };

  self.removeChild = function () {
    if (self.numberOfChildren() > minNumberOfChildren) {
      self.numberOfChildren(self.numberOfChildren() - 1);
    }
  };

  self.isValid = ko.pureComputed(function () {
    if (this.numberOfAdults() < 0 || this.numberOfAdults() > maxNumberOfAdults || this.numberOfChildren() < minNumberOfChildren || this.numberOfChildren() > 40) {
      return false;
    } else {
      if (this.numberOfChildren() > 0) {
        if (this.numberOfAdults() == 0) {
          return false;
        } else {
          var ageOk = true;
          for (var i = 0; i < this.childrenAges().length; i++) {
            if (this.childrenAges()[i].Age() == '') {
              ageOk = false;
            }
          }
          return ageOk;
        }
      } else {
        return true;
      }
    }
  }, self);

  self.numberOfAdults.subscribe(update);
  self.numberOfChildren.subscribe(update);

  function setContent() {
    if (self.adults() == 0) {
      content('');
    } else if (self.children() == 0) {
      content(self.adults() + ' Erw.');
    } else {
      content(self.adults() + ' Erw., ' + self.children() + (self.children() == '1' ? ' Kind' : ' Kinder'));
    }
  }

  function valid() {
    if (self.numberOfAdults() < 0 || self.numberOfAdults() > maxNumberOfAdults || self.numberOfChildren() < minNumberOfChildren || self.numberOfChildren() > 40) {
      return false;
    } else {
      if (self.numberOfChildren() > 0) {
        if (self.numberOfAdults() == 0) {
          return false;
        } else {
          var ageOk = true;
          for (var i = 0; i < self.childrenAges().length; i++) {
            if (self.childrenAges()[i].Age() == '') {
              ageOk = false;
            }
          }
          return ageOk;
        }
      } else {
        return true;
      }
    }
  }

  function update() {
    if (valid()) {
      self.adults(self.numberOfAdults() + '');
      self.children(self.numberOfChildren() + '');
      for (var i = 0; i < self.childrenAges().length; i++) {
        self.childAges()[i].Age(self.childrenAges()[i].Age());
      }

      $(componentInfo.element).trigger('personsselected');
    }
  }

  function setInitial() {
    self.initialNumberOfAdults = persons.Adults();
    self.initialNumberOfChildren = persons.Children();
    self.initialChildAges = [];
    for (var i = 0; i < persons.ChildAges().length; i++) {
      self.initialChildAges[i] = persons.ChildAges()[i].Age();
    }
  }
}

function ChildAgeViewModel(index, data, onUpdate) {
  this.Index = index;
  this.Age = ko.observable(data);
  this.Age.subscribe(onUpdate);
}
